module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!this.kombox.id) ? [_c('div', {
    staticClass: "media-body media-right text-right"
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": _vm.isAclReader,
      "title": "Neuer Eintrag",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editModus = true
      }
    }
  }, [_vm._v("\n        Neue Kombox\n      ")])])] : [_c('div', {
    staticClass: "media-body "
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left media-middle",
    attrs: {
      "title": _vm.KomboxConf.TYPES[_vm.kombox.type].SYMBOL.TITLE
    }
  }, [_c('span', {
    staticClass: "glyphicon",
    class: [_vm.KomboxConf.TYPES[_vm.kombox.type].SYMBOL.CLASS, _vm.KomboxConf.ACLS[_vm.kombox.acl].SYMBOL.CLASS]
  })]), _vm._v(" "), _c('a', {
    staticClass: "media-body cc-kombox-body ",
    attrs: {
      "href": "",
      "title": _vm.kombox.content
    },
    on: {
      "click": function($event) {
        return _vm.onClickContent($event)
      }
    }
  }, [(_vm.kombox.acl == 3) ? _c('strong', [_vm._v("*******")]) : _c('strong', {}, [_vm._v(_vm._s(_vm.contentView))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {}, [_vm._v(_vm._s(_vm.kombox.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "media-right text-right media-middle"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kombox.shippingActiv > 0),
      expression: "kombox.shippingActiv > 0"
    }],
    staticClass: "btn btn-xs btn-default",
    class: {
      'btn-success': _vm.shippingAktive
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickShipping
    }
  }, [(['8', '9', '10'].indexOf(_vm.kombox.type) > -1) ? _c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('span', {
    staticClass: "glyphicon glyphicon-send"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-link cc-btn-menue",
    attrs: {
      "type": "button",
      "disabled": _vm.isAclReader,
      "title": "Eintrag bearbeiten"
    },
    on: {
      "click": function($event) {
        _vm.editModus = true
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-option-vertical"
  })])])], _vm._v(" "), (_vm.editModus) ? _c('cc-kombox-modal', {
    attrs: {
      "kombox": _vm.kombox
    },
    on: {
      "cancel": _vm.cancel,
      "remove": _vm.remove,
      "save": _vm.save
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showExternSite) ? _c('cc-extern-site', {
    attrs: {
      "type": _vm.kombox.type,
      "content": _vm.kombox.content
    },
    on: {
      "cancel": function($event) {
        _vm.showExternSite = false
      },
      "commit": function($event) {
        _vm.showExternSite = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPhoneTool) ? _c('cc-phone-tool', {
    attrs: {
      "kombox": _vm.kombox,
      "content": _vm.kombox.content
    },
    on: {
      "close": function($event) {
        _vm.showPhoneTool = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ef5afc5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Kombox.vue
// module id = 266
// module chunks = 0